module.exports = __webpack_public_path__ + "a2a3de8cafb0890363b6b4c87ec25d20.svg";